import { MutationTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { MerchantModel } from '@/models/MerchantModel';
import { LocationPoint, ShopFilter } from '@/types';
import { SearchMethod } from '@/enums/search-method';
import { CurbsideModel } from '@/models/CurbsideModel';
import { RootState } from './state';

const mutations: MutationTree<RootState> = {

  [ActionTypes.GetMerchantsPage](state: RootState, {
    initialPage = true,
    merchantList = [],
  }: {
    initialPage: boolean;
    merchantList: MerchantModel[];
  }) {
    if (initialPage) {
      state.merchantList = merchantList;
    } else {
      state.merchantList.push(...merchantList);
    }
  },

  [ActionTypes.SetLocation](state: RootState, location: LocationPoint | null) {
    state.location = location;
  },

  [ActionTypes.SetSearchMethod](state: RootState, searchMethod: SearchMethod) {
    state.searchMethod = searchMethod;
  },

  [ActionTypes.SetSearchFilter](state: RootState, searchName: string) {
    state.shopFilter.searchName = searchName;
  },

  [ActionTypes.SetShopFilter](state: RootState, shopFilter: ShopFilter) {
    state.shopFilter = {
      ...state.shopFilter,
      ...shopFilter,
    };
  },

  [ActionTypes.SetCurbsideData](state: RootState, curbsideData: CurbsideModel) {
    state.curbsideData = curbsideData;
  },

};

export default mutations;
